"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorLink = void 0;
const error_1 = require("@apollo/client/link/error");
const graphql_1 = require("graphql");
// Log any GraphQL errors or network error that occurred
exports.errorLink = (0, error_1.onError)(({ graphQLErrors, networkError, operation }) => {
    const { variables, operationName, query } = operation;
    if (graphQLErrors)
        graphQLErrors.forEach(({ message, path }) => {
            if (process.env.NODE_ENV === 'production') {
                // eslint-disable-next-line no-console
                console.log(`[GraphQLError]: ${JSON.stringify({
                    operationName,
                    message,
                    variables,
                    path,
                }, null, 2)}`);
            }
            else {
                // eslint-disable-next-line no-console
                console.log(`[GraphQLError]: ${JSON.stringify({
                    operationName,
                    message,
                    variables,
                    query: (0, graphql_1.print)(query),
                    path,
                }, null, 2)}`);
            }
        });
    // eslint-disable-next-line no-console
    if (networkError)
        console.log(`[Network error]: ${networkError}`);
});
//# sourceMappingURL=errorLink.js.map